
const dataSlider = [
  {
    ide: 1,
    title: "Bienvenido",
    subTitle: "Vulputate, ante leo fermentum nulla, sit amet ornare lorem eros a massa, leo fermentum.", 
    background: "1x1.gif",
    image: "empecemos.svg"
  },
  {
    ide: 2,
    title: "Propuesta valor",
    subTitle: "Lorem ipsum dolor sit amet, adipiscing elit. Donec fermentum, tellus ac molestie.", 
    background: "1x1.gif",
    image: "valor.svg"
  },
  {
    ide: 3,
    title: "¡Tú ganas!",
    subTitle: "Vulputate, ante leo fermentum nulla, sit amet ornare lorem eros a massa, leo fermentum.", 
    background: "1x1.gif",
    image: "ganas.svg"
  },
  {
    ide: 4,
    title: "...y de Regalo!",
    subTitle: "Lorem ipsum dolor sit amet, consectetur elit. Donec fermentum, tellus ac molestie.", 
    background: "1x1.gif",
    image: "bienvenida.svg"
  }
];

export default dataSlider;